import { useState, useEffect } from 'react';

/**
 * Code copied from
 *
 * packages/comments-drawer/src/CommentsDrawer/Mobile/MobileCommentButtons.tsx#L151
 */
export const useMediaQueryVisibility = (mediaQuery: string) => {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const queryHandler = (e: MediaQueryListEvent) => {
      setVisible(e.matches);
    };
    const query = window.matchMedia(mediaQuery);
    setVisible(query.matches);
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', queryHandler);
      return () => {
        query.removeEventListener('change', queryHandler);
      };
    }
    // Backwards compatibility for older browsers
    else if (typeof query.addListener === 'function') {
      query.addListener(queryHandler);
      return () => {
        query.removeListener(queryHandler);
      };
    }
  }, []);

  return isVisible;
};
